export const MapeamentoTabelaFuncionalidade: Map<string, string> = new Map([
  ['esaber_config - curriculo_composicao', 'Educacional Composição de Currículo'],
  ['esaber_educacional - curriculo_composicao_curricular', 'Educacional Composição de Currículo']
]);
